import React from 'react';
import { BookOpen } from 'lucide-react';

/**
 * Component for selecting D&D ruleset (2014 or 2024)
 */
const RulesetSelector = ({ onSelectRuleset }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold text-center mb-6">D&D Character Generator</h1>
        <p className="text-gray-600 mb-8 text-center">Select which D&D 5e ruleset to use:</p>
        
        <div className="flex flex-col space-y-4">
          <button
            onClick={() => onSelectRuleset('2014')}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg flex items-center justify-center"
          >
            <BookOpen className="mr-2" />
            2014 Rules (Original 5e)
          </button>
          
          <button
            onClick={() => onSelectRuleset('2024')}
            className="bg-purple-600 hover:bg-purple-700 text-white font-bold py-4 px-6 rounded-lg flex items-center justify-center"
          >
            <BookOpen className="mr-2" />
            2024 Rules (Updated 5e)
          </button>
        </div>
      </div>
    </div>
  );
};

export default RulesetSelector;
